import { check } from './shared/data/learning/learning';

import { AppConfig } from "./interfaces/app-config";

export var globalConfig: AppConfig = {

    logoIcon: '/assets/img/ctlp/img/isotipo.svg',
    logoIconWhite: '/assets/img/ctlp/img/isotipo-white.svg',
    logo: '/assets/img/ctlp/img/logo.png',
    logoSVG: '/assets/img/ctlp/img/isologo.svg',
    logoWhiteSVG: '/assets/img/ctlp/img/isologo-white.svg',
    logoWhite: '/assets/img/ctlp/img/logo-white.png',

    metadata: {
        title: 'CTLP',
        subtitle: 'CTLP',
        description: 'Compra tus entradas para disfrutar de buenos momentos en Club Ámbar SCL',
        keywords: 'ticket, club ambar, ticket ambar, ticket ambar scl',
        favicon: '/assets/img/ctlp/icon/favicon.ico',
    },
    colors: {
        primary: '#1A5633',
        secondary: '#AE9A65',
        tertiary: '#000000',
    },
    fonts: {
      title: 'Rubik',
      subtext: 'Montserrat',
      text: 'Roboto',
    },
    styles: "@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');",

    authRedirect: '',
    // Seats IO
    region: 'sa',
    keyEncript: '3fa85f64c2f9e0c53fa85f64c2f9e0c5',
    ivEncript: 'c2f9e0c53fa85f64',

    yearProyect: 2025,
    keyRecaptcha: null,
    menu: [
            {
                headTitle1: "General",
                permissions:'default',
            },
            {
                id: 1,
                level: 1,
                path: '/account',
                title: "Mi Cuenta",
                icon: "home",
                type: "link",
                horizontal: false,
                permissions:'default',
            },
            {
                headTitle1: "Usuarios",
                permissions:'default',
            },
            {
                id: 2,
                level: 1,
                path: '/users',
                title: "Usuarios del admin",
                icon: "bookmark",
                type: "link",
                horizontal: false,
                permissions:'organization-page-users',
            },
            {
                id: 3,
                level: 1,
                path: '/profile',
                title: "Perfiles",
                icon: "bookmark",
                type: "link",
                permissions:'organization-page-profiles',
            },
            {
                id: 4,
                level: 1,
                path: '/customer',
                title: "Usuarios CTLP Portal",
                icon: "bookmark",
                type: "link",
                horizontal: false,
                permissions:'organization-page-customers',
            },
            {
                id: 5,
                level: 1,
                path: '/partners',
                title: "Socios",
                icon: "bookmark",
                type: "link",
                horizontal: false,
                permissions:'payment-page-partners',
            },


            {
                headTitle1: "Caja",
                permissions:'default',
            },
            {
              id: 3,
              level: 1,
              path: 'transactions',
              title: "Historia de Transacciones",
              icon: "",
              type: "link",
              permissions:'payments-page-transactions',
            },
            {
              id: 4,
              level: 1,
              path: 'cashier-checkout',
              title: "Caja de servicios",
              icon: "",
              type: "link",
              permissions:'payments-page-cashier_checkout',
            },
            {
                headTitle1: "Notificaciones",
                permissions:'organization-page-send_email',
            },
            {
                id: 5,
                level: 1,
                path: 'send-email',
                title: "Correos enviados",
                icon: "bookmark",
                type: "link",
                permissions:'notification-page-send_email',
            },
            {
                id: 5,
                level: 1,
                path: 'send-email/create',
                title: "Enviar correo",
                icon: "bookmark",
                type: "link",
                permissions:'notification-page-send_email',
            },
            {
                id: 6,
                level: 1,
                path: 'templates',
                title: "Plantilla",
                icon: "bookmark",
                type: "link",
                permissions:'notification-page-template',
            },
        ],
    horizontalMenu: [],
    staticMap: false,
    keyMap: 'AIzaSyCbWR6PgxPfBaPOgwkV0QRvvXhwxSDFyaM',
    authGoogle: true,
    authGuest: true,
    currency: 'Bs',
    gtmId: null,
    bgDarkRoutes: [],
    bgCustomRoutes: [],
    pages: {
        login: {
            title: 'Iniciar sesión',
            subtitle: 'Introduzca su correo electrónico y contraseña para iniciar sesión',
            form: {
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                rememberMe: {
                    label: 'Recordarme'
                },
                agency_id: {
                    label: 'Agencias',
                    placeholder: 'Seleccionar...'
                },
            },
            socialAuth: 'O inicia sesión con',
            forgotPassword: '¿Ha olvidado su contraseña?',
            submit: 'Iniciar sesión',
            nextAuth: {
                question: '¿No tienes cuenta?',
                action: 'Registrate aquí'
            }
        },
        register: {
            title: 'Registrate',
            subtitle: 'Introduzca sus datos personales para crear una cuenta',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                terms: {
                    label: 'Acepto los ',
                    action: 'términos y condiciones'
                }
            },
            socialAuth: 'O registrate con',
            submit: 'Registrarse',
            nextAuth: {
                question: '¿Ya tienes una cuenta?',
                action: 'Inicia sesión'
            }
        },
        forgetPassword: {
            title: 'Recuperar contraseña',
            subtitle: 'Introduzca correo electronico de registro.',
            form: {
                code: {
                    label: 'Código',
                    placeholder: 'Escribir código...',
                    action: 'Ingresa el código enviado a su correo de recuperación'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico',
                    action: "Ingresa el correo con el que te registraste para recuperar tu contraseña"
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña',
                    action: "Ingrese una nueva contraseña, como mínimo debe tener 8 caracteres"
                },
                passwordConfir: {
                    label: 'Confirmar contraseña',
                    placeholder: 'Confirmar contraseña...'
                },
                passwordCurrent: {
                    label: 'Contraseña actual',
                    placeholder: 'Escribir contraseña...'
                }
            },
            socialAuth: 'O registrate con',
            submit: 'Registrarse',
            nextAuth: {
                question: '',
                action: 'Ir a Inicia sesión'
            }
        },
        account: {
            titlePlural: 'Mi cuenta',
            titleSingular: 'Micunta',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },

            },
        },
        users: {
          titlePlural: 'Usuarios',
          titleSingular: 'Usuario',
          form:{},
          forms:[
            { id:'name',        value: null,    label: 'Nombres y Apellidos',    type:'text',       placeholder:'Ej. Pedro Mendez...',   options: [],  permission:null,   size:4, required: true,   multiple: false},
            { id:'email',       value: null,    label: 'Correo electrónico',     type:'email',      placeholder:'Ej. admin@gmail.com',   options: [],  permission:null,   size:4, required: true,   multiple: false},
            { id:'password',    value: null,    label: 'Contraseña',             type:'password',   placeholder:'**********',        options: [],  permission:null,   size:4, required: true,   multiple: false},
            { id:'role_id',     value: null,    label: 'Asignar rol',            type:'select',     placeholder:'Seleccionar...',    options: [],  permission:null,   size:4, required: true,   multiple: false},
            { id:'agency_id',   value: null,    label: 'Agencia',                type:'select',     placeholder:'Seleccionar...',    options: [],  permission:null,   size:4, required: false,  multiple: false},
            { id:'city_id',     value: null,    label: 'Ciudad',                 type:'select',     placeholder:'Seleccionar...',    options: [],  permission:null,   size:4, required: false,  multiple: false},
          ],
          form_filters: [
            { id:'name',          value: null,    label: 'Nombres y Apellidos',    type:'text',   placeholder:'Ej. Pedro Mendez...',   options: [],  permission:null,   size:1},
            { id:'email',         value: null,    label: 'Correo electrónico',    type:'text',   placeholder: 'Ej. admin@gmail.com',   options: [],  permission:null,   size:1},
            { id:'business_id',   value: null,    label: 'Empresa',    type:'select',   placeholder:'Seleccionar...',   options: [],  permission:null,    size:1},
            { id:'active',        value: null,    label: 'Estado',    type:'select',   placeholder:'Seleccionar...',   options: [{id:'1',name:'Activo'}, {id:'0', name:'Desactivado' }],  permission:  null,size:1},
          ],
          table: [
            { id: 'name',             name:'Nombre',                active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'email',            name:'Correo electrónico',    active:true,   permission:null,   sort: false,      sortArrow: 'asc' },
            { id: 'is_assigned',      name:'Accesos',               active:true,   permission:null,   sort: false,      sortArrow: 'asc' },
            { id: 'column_action',    name:'Acciones',              active:true,   permission:null,   sort: false,      sortArrow: 'asc' },
          ]
        },
        customer: {
            titlePlural: 'Clientes',
            titleSingular: 'Cliente',
            form: {},

            forms:[
              { id:'name',       value: null,    label: 'Nombres y Apellidos',    type:'text',       placeholder:'Ej. Pedro Mendez',        options: [],  permission:null,   size:4, required: true,   multiple: true},
              { id:'email',      value: null,    label: 'Correo electrónico',     type:'email',      placeholder:'Ej. usuario@gmail.com',   options: [],  permission:null,   size:4, required: false,  multiple: false},
              { id:'cellphone',  value: null,    label: 'Celular',                type:'number',     placeholder:'Ej. 89451200',            options: [],  permission:null,   size:4, required: false,  multiple: false},
              { id:'password',   value: null,    label: 'Contraseña',             type:'password',   placeholder:'Ej. 1********',           options: [],  permission:null,   size:4, required: true,   multiple: false},
            ],
            form_filters: [
              { id:'name',          value: null,    label: 'Nombres y Apellidos',  type:'text',   placeholder:'Ej. Pedro Mendez',       options: [],  permission:null,   size:1},
              { id:'email',         value: null,    label: 'Correo electrónico',   type:'email',  placeholder:'Ej. usuario@gmail.com',  options: [],  permission:null,   size:1},
              { id:'cellphone',     value: null,    label: 'Celular',              type:'number', placeholder:'Ej. 89451200',           options: [],  permission:null,   size:1},
              { id:'initial_date',  value: null,    label: 'Fecha inicio',         type:'date',   placeholder:'Ej. 01-02-2020',         options: [],  permission:null,   size:1},
              { id:'end_date',      value: null,    label: 'Fecha fin',            type:'date',   placeholder:'Ej. 03-03-2025',         options: [],  permission:null,   size:1},
            ],

            table: [
              { id: 'name',           name:'Nombre',              active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'profile_ci',        name:'CI',                  active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'email',          name:'Correo electrónico',  active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'cellphone',      name:'Celular',             active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'login_admin',    name:'Ingresar',            active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'column_action',  name:'Acciones',            active:true,   permission:null,   sort: false,     sortArrow: 'asc' },
            ],

        },
        partners: {
            titlePlural: 'Socios',
            titleSingular: 'Socio',
            form: {},

            forms:[
            { id:'name',        value: null,    label: 'Nombres',               type:'text',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: true,     multiple: false},
            { id:'ci_number',   value: null,    label: 'Cédula de identidad',   type:'text',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: true,     multiple: false},
            { id:'email',       value: null,    label: 'Correo electrónico',    type:'email',    placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: false,    multiple: false},
            { id:'cellphone',   value: null,    label: 'Telefoino',             type:'number',    placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: false,    multiple: false},
            { id:'code',        value: null,    label: 'Código',                type:'text',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: false,    multiple: false},
            { id:'active',      value: null,    label: 'Activar',               type:'select',   placeholder:'Seleccionar...',   options: [{id:true, name: 'SI'}, {id:false, name: 'NO'}],      permission:null,   size:4,   required: false,    multiple: false},
          ],
            form_filters: [
              { id:'name',          value: null,    label: 'Nombres y Apellidos',  type:'text',   placeholder:'Ej. Pedro Mendez',       options: [],  permission:null,   size:1},
              { id:'email',         value: null,    label: 'Correo electrónico',   type:'email',  placeholder:'Ej. usuario@gmail.com',  options: [],  permission:null,   size:1},
              { id:'cellphone',     value: null,    label: 'Celular',              type:'number', placeholder:'Ej. 89451200',           options: [],  permission:null,   size:1},
              { id:'ci_number',     value: null,    label: 'Cédula de identidad',  type:'number', placeholder:'Ej. 89451200',           options: [],  permission:null,   size:1},
              { id:'code',          value: null,    label: 'Código',               type:'text', placeholder:'Ej. 89451200',           options: [],  permission:null,   size:1},
            ],

            table: [
              { id: 'name',           name:'Nombre',               active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'ci_number',      name:'CI.',                  active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'code',           name:'Código',               active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'email',          name:'Correo electrónico',   active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'cellphone',      name:'Telefono',             active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'column_action',  name:'Acciones',            active:true,    permission:null,   sort: false,    sortArrow: 'asc' },
            ],

        },
        profile: {
          titlePlural: 'Perfiles',
          titleSingular: 'Perfil',
            form:{
                name: {
                    label: 'Nombre',
                    placeholder: 'Escribir nombre'
                },
                last_name: {
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Escribir celular...'
                },
                birth_date: {
                    label: 'Fecha de nacimiento',
                    placeholder: 'Escribir Fecha de nacimiento...'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Escribir ciudad...'
                },
                country: {
                    label: 'País',
                    placeholder: 'Escribir paós...'
                },
                ci:{
                    label: 'Carnet',
                    placeholder: 'Ingrese...'
                },
            },

          forms:[
            { id:'first_name',       value: null,  label: 'Nombres',               type:'text',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: true,     multiple: false},
            { id:'last_name',        value: null,  label: 'Apellidos',             type:'text',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: true,     multiple: false},
            { id:'email',            value: null,  label: 'Correo electrónico',    type:'email',    placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: true,     multiple: false},
            { id:'country_identity', value: null,  label: 'Cédula de identidad',   type:'text',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: true,     multiple: false},
            { id:'cellphone',        value: null,  label: 'Celular',               type:'number',   placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: false,    multiple: false},
            { id:'birth_date',       value: null,  label: 'Fecha de nacimiento',   type:'date',     placeholder:'Escribir...',      options: [],  permission:null,   size:4,   required: false,    multiple: false},
            { id:'city_id',          value: null,  label: 'Ciudad',                type:'select',   placeholder:'Seleccionar...',   options: [],  permission:null,   size:4,   required: false,    multiple: false},
            { id:'country_id',       value: null,  label: 'País',                  type:'select',   placeholder:'Seleccionar...',   options: [],  permission:null,   size:4,   required: false,    multiple: false},
            //{ id:'code',             value: 'BO',  label: 'Nombres y Apellidos',   type:'text',     placeholder:'Escribir...',   options: [],  permission:null,   size:4,   required: false,    multiple: false},
          ],

          form_filters: [
            { id:'first_name',          value: null,    label: 'Nombres',               type:'text',   placeholder:'Ej. Pedro...',          options: [],  permission:null,   size:1},
            { id:'last_name',           value: null,    label: 'Apellidos',             type:'text',   placeholder:'Ej. Cardozo...',        options: [],  permission:null,   size:1},
            { id:'email',               value: null,    label: 'Correo electrónico',    type:'email',  placeholder:'Ej. usuario@gmail.com', options: [],  permission:null,   size:1},
            { id:'country_identity',    value: null,    label: 'Numero de carnet',      type:'text',   placeholder:'Ej. 78890233',          options: [],  permission:null,   size:1},
            { id:'city_id',             value: null,    label: 'Ciudad',                type:'select', placeholder:'Ej. Seleccionar...',    options: [],  permission:null,   size:1},
            { id:'initial_date',        value: null,    label: 'Fecha inicio',          type:'date',   placeholder:'Ej. 01-02-2020',        options: [],  permission:null,   size:1},
            { id:'end_date',            value: null,    label: 'Fecha fin',             type:'date',   placeholder:'Ej. 01-02-2020',        options: [],  permission:null,   size:1},
          ],
          table: [
            { id: 'first_name',         name:'Nombre',                active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'last_name',          name:'Apellido',              active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'email',              name:'Correo electrónico',    active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'cellphone',          name:'Teléfono',              active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'country_identity',   name:'Número de carnet',      active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'birth_date',         name:'Fecha de nacimiento',   active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            { id: 'column_action',    name:'Acciones',              active:true,   permission:null,   sort: false,      sortArrow: 'asc' },
          ],
        },
        agency: {
            titlePlural: 'Agencias',
            titleSingular: 'Agencia',
            form: {
                name: {
                    label: 'Nombre de la agencia ',
                    placeholder: 'Ingresa tu nombre..'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Ingresa dirección...'
                },
                phone: {
                    label: 'Telefono',
                    placeholder: 'Ingresa telefono...'
                },
                business: {
                    label: 'Empresa',
                    placeholder: 'Ingresa nombre de empresa...'
                },
                latitude: {
                    label: 'Latitude',
                    placeholder: 'Latitude....'
                },
                longitude: {
                    label: 'Longitude',
                    placeholder: 'Longitude....'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa descripción....'
                }
            },

            forms:[
              { id:'name',           value: null,  label: 'Nombre de la agencia',  type:'text',     placeholder:'Escribir...',    options: [],  permission:null,   size:4,   required: true,     multiple: false},
              { id:'address',        value: null,  label: 'Dirección',             type:'text',     placeholder:'Escribir...',    options: [],  permission:null,   size:4,   required: false,     multiple: false},
              { id:'business_id',    value: null,  label: 'Empresa',               type:'select',   placeholder:'Escribir...',    options: [],  permission:null,   size:4,   required: true,     multiple: false},
            ],
            form_filters:[
              //{ id:'first_name',          value: null,    label: 'Nombres',               type:'text',   placeholder:'Ej. Pedro...',          options: [],  permission:null,   size:1},
            ],
            table:[
              { id: 'name',           name:'Nombre',         active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'address',        name:'Dirección',      active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'business',       name:'Empresa',        active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'column_action',  name:'Acciones',       active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            ],
        },

        transactions: {
            titlePlural: 'Historial de transacciones',
            titleSingular: 'historial de transacción',
            form:{},

            forms:[
              { id:'name',           value: null,  label: 'Nombre de la agencia',  type:'text',     placeholder:'Escribir...',    options: [],  permission:null,   size:4,   required: true,     multiple: false},
            ],
            form_filters:[
              { id:'user_id',                   value: null,    label: 'Usuario',                       type:'select',    placeholder:'Escribir...',    options: [],  permission:'filter-user-cashier',   size:2},
              { id:'payment_method_id',         value: null,    label: 'Método de pago',                type:'select',    placeholder:'Escribir...',    options: [],  permission:null,   size:1},
              { id:'ci_number',                 value: null,    label: 'Cedula de identidad',           type:'text',      placeholder:'Escribir...',    options: [],  permission:null,   size:1},
              { id:'email',                     value: null,    label: 'Correo electrónico',            type:'email',     placeholder:'Escribir...',    options: [],  permission:null,   size:1},
              { id:'cellphone',                 value: null,    label: 'Teléfono',                      type:'number',    placeholder:'Escribir...',    options: [],  permission:null,   size:1},
              //{ id:'status',                    value: null,    label: 'Estado',                        type:'select',    placeholder:'Eecribir...',    options: [],  permission:null,   size:1},
              { id:'created_at_from',           value: null,    label: 'Fecha de creación (Desde)',     type:'date',      placeholder:'Escribir...',    options: [],  permission:null,   size:1},
              { id:'created_at_to',             value: null,    label: 'Fecha de creación (Hasta)',     type:'date',      placeholder:'Escribir...',    options: [],  permission:null,   size:1},

            ],
            table:[
              { id: 'cashier_user',           name:'Cajero',                  active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'detail_colum',           name:'Socio',   active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'payments_name',          name:'Descripción',             active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'payments_payment_date',  name:'Fecha por periodo',       active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'payments_amount',        name:'Monto',                   active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'payments_cant',          name:'Cant. Deudas',            active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'recinv_array',           name:'Factura(s)/Recibo(s)',    active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'detail',                 name:'Detalles',                active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            ],
        },
        cashier: {
          titlePlural: 'Cajas de servicio',
          titleSingular: 'Cajas de servicios',
          form:{}
        },

        templea: {
            titlePlural: 'Plantillas',
            titleSingular: 'Plantilla',
            form:{
                name: {
                    label: 'Titulo de la plantilla',
                    placeholder: 'Escribir...'
                },
                type: {
                    label: 'Tipo de plantilla',
                    placeholder: 'Seleccionar...'
                },
                typeNotification: {
                    label: 'Tipo notificacción',
                    placeholder: 'Seleccionar...'
                },
                description: {
                    label: 'Contenido',
                    placeholder: 'Escribir...'
                },
            },
            form_filter: {}
        },
        sendMail: {
            titlePlural: 'Correos enviados',
            titleSingular: 'Correo enviado',
            form:{},
            forms:[],
            form_filters: [
              { id:'notification_type_id', value: null,    label: 'Tipo de notificación',  type:'select',   placeholder:'Seleccionar...',       options: [],  permission:null,   size:1},
              { id:'status',               value: null,    label: 'Estado',                type:'select',   placeholder:'Seleccionar...',       options: [{id: "success",name: "Enviados"},{id: "error",name: "No enviados"},{id: "pending", name: "Pendientes"},],  permission:null,   size:1},
              { id:'token',                value: null,    label: 'Buscar por token',      type:'text',     placeholder:'Escribir...',          options: [],  permission:null,   size:1},
            ],
            table: [
              { id: 'token',      name:'Token',      active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'title',      name:'Titulo',     active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'status',     name:'Estado',     active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
              { id: 'message',    name:'Mensaje',    active:true,   permission:null,   sort: false,    sortArrow: 'asc' },
            ],
        },

        sendMailCustom: {
            titlePlural: 'Enviar correos',
            titleSingular: 'Enviar correo',
            form:{
                title: {
                    label: 'Titulo',
                    placeholder: 'Escribir titulo...'
                },
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                segment:{
                    label: 'Segmento de usuarios',
                    placeholder: 'Seleccionar...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir Correo electrónico...'
                },
                link:{
                    label: 'Link de ticket',
                    placeholder: 'Escribir link...'
                },
                content:{
                    label: 'Contenido',
                    placeholder: 'Escribir texto del correo...'
                },
                template_id:{
                    label: 'Plantilla',
                    placeholder: 'Seleccionar...'
                },

                image:{
                    label: 'Imagen',
                    placeholder: 'Escribir...'
                },
                name:{
                    label: 'Nombre del evento',
                    placeholder: 'Escribir...'
                },
                stage:{
                    label: 'Nombre del predio',
                    placeholder: 'Escribir...'
                },
                date:{
                    label: 'Fecha del evento',
                    placeholder: 'Escribir...'
                },
                time:{
                    label: 'Hora del evento',
                    placeholder: 'Escribir...'
                },
                order:{
                    label: 'Orden',
                    placeholder: 'Escribir...'
                },
                quantity:{
                    label: 'Cantidad',
                    placeholder: 'Escribir...'
                },
                city:{
                    label: 'Ciudad',
                    placeholder: 'Escribir...'
                },
            },
            form_filter: {
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                status:{
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
                token:{
                    label: 'Buscar por token',
                    placeholder: 'Escribir...'
                },
            }
        },

        invoices: {
            titlePlural: 'Facturas',
            titleSingular: 'Factura',
            form:{
                "type": {
                    label: 'Tipo de deuda',
                    placeholder: 'Seleccionar...'
                },
                ci: {
                    label: 'CI',
                    placeholder: '...'
                },
                nit_number: {
                    label: 'NIT',
                    placeholder: '...'
                },
                email: {
                    label: 'Email',
                    placeholder: '...'
                },
                name: {
                    label: 'Nombre',
                    placeholder: '...'
                },
                status: {
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
                payment_date_from: {
                    label: 'Fecha de pago (Desde)',
                    placeholder: 'Seleccionar...'
                },
                payment_date_to: {
                    label: 'Fecha de pago (Hasta)',
                    placeholder: 'Seleccionar...'
                },
                created_at_from: {
                    label: 'Fecha de creación (Desde)',
                    placeholder: 'Seleccionar...'
                },
                created_at_to: {
                    label: 'Fecha de creación (Hasta)',
                    placeholder: 'Seleccionar...'
                }
            }
        },
        payment_methods: {
            titlePlural: 'Métodos de pago',
            titleSingular: 'Método de pago',
            form:{
                payment_channel_id: {
                    label: 'Canal de pago',
                    placeholder: 'Seleccionar...'
                },
                active: {
                    label: '¿Activo?',
                    placeholder: 'Seleccionar...'
                },
                created_at_from: {
                    label: 'Fecha de creación (Desde)',
                    placeholder: 'Seleccionar...'
                },
                created_at_to: {
                    label: 'Fecha de creación (Hasta)',
                    placeholder: 'Seleccionar...'
                }
            }
        },
        seats: {
            titlePlural: 'Reporte de asientos',
            titleSingular: 'Reporte de asiento',
            form:{},
        },
        deliveryTicket: {
            titlePlural: 'Entregas de Tickets',
            titleSingular: 'Entrega de Ticket',
            form:{},
        },
        typePayment: {
            titlePlural: 'Tipos de métodos de pagos',
            titleSingular: 'Tipo de método de pago',
            form:{},
        },
        paymentCustom: {
            titlePlural: 'Pagos',
            titleSingular: 'Pago',
            form:{},
        },
        carryDebts: {
            titlePlural: 'Cargar Deudas',
            titleSingular: 'Carga Deuda',
            form:{},
            form_filter: {}
        },
        parameters: {
            titlePlural: 'Parametros',
            titleSingular: 'Parametro',
            form:{},
            form_filter: {}
        },
        payments: {
            titlePlural: 'Pagos',
            titleSingular: 'Pago',
            form:{
                user_id: {
                    label: 'Usuario',
                    placeholder: 'Seleccionar...'
                },
                identifier: {
                    label: 'Identificado enviado',
                    placeholder: 'Escribir...'
                },
                ci_number: {
                    label: 'Carnet de identidad',
                    placeholder: 'Escribir...'
                },
                email: {
                    label: 'Email',
                    placeholder: 'Escribir...'
                },
                cellphone: {
                    label: 'Teléfono',
                    placeholder: 'Escribir...'
                },
                status: {
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
                payment_date_from: {
                    label: 'Fecha de pago (Desde)',
                    placeholder: 'Seleccionar...'
                },
                payment_date_to: {
                    label: 'Fecha de pago (Hasta)',
                    placeholder: 'Seleccionar...'
                },
                created_at_from: {
                    label: 'Fecha de creación (Desde)',
                    placeholder: 'Seleccionar...'
                },
                created_at_to: {
                    label: 'Fecha de creación (Hasta)',
                    placeholder: 'Seleccionar...'
                }
            }
        },
        roles: {
            titlePlural: 'Roles',
            titleSingular: 'Rol',
            form: {
                name: {
                    label: 'Nombre del rol',
                    placeholder: 'Ingresar nombre...'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa, descripción y alcance del rol...'
                },
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                initial_date: {
                    label: 'Fecha inicio',
                    placeholder: 'Ingresa fecha inicio'
                },
                end_date: {
                    label: 'Fecha fin',
                    placeholder: 'Ingresa fecha fin'
                },
            }
        },
        permissions: {
            titlePlural: 'Permisos',
            titleSingular: 'Permiso',
            form: {
                name: {
                    label: 'Nombre del permisio',
                    placeholder: 'Ingresar nombre...'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa, descripción y alcance del rol...'
                },
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                initial_date: {
                    label: 'Fecha inicio',
                    placeholder: 'Ingresa fecha inicio'
                },
                end_date: {
                    label: 'Fecha fin',
                    placeholder: 'Ingresa fecha fin'
                },
            }
        },



    },
    validations: {
        required: "El campo \"{label}\" es requerido.",
        number: "El campo \"{label}\" debe contener solo números.",
        minlength: "El campo \"{label}\" debe tener al menos \"{requiredLength}\" caracteres.",
        maxlength: "El campo \"{label}\" debe tener un máximo de \"{requiredLength}\" caracteres.",
        min: "El campo \"{label}\" debe contener al menos \"{min}\" elementos.",
        max: "El campo \"{label}\" debe tener un máximo de \"{max}\" elementos.",
        email: "El campo \"{label}\" debe ser un email válido.",
        default: "El campo \"{label}\" es inválido.",
    },

    byDevelopment: 'Desarrollado por Libélula',

    //bridge: {
    //    apiUrl: 'https://bridge.prod.todotix.net/',
    //    xApiKey: 'cf6114b2-11f7-470d-8494-62e254a911d1',
    //    xSecretKey: '50f20c87-a240-48cd-8ef2-9b5dbc6ee702',
    //    enabledPOS: true,
    //    keyUser: 'c71b4f34-9f4b-430f-a26d-5ac34416015e', // Provider APIKEY
    //},
    bridge: {
        apiUrl: 'https://bridge.test.todotix.net/',
        xApiKey: '88114f76-9ee4-42f3-924c-6bbda04fc79e',
        xSecretKey: 'ffc754c0-4dc2-4fee-85a1-42ba65a96726',
        enabledPOS: true,
        keyUser: 'c71b4f34-9f4b-430f-a26d-5ac34416015e', // Provider APIKEY
    },

};
